// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-Voucher__wrapper","inputWrapper":"c-Voucher__inputWrapper","input":"c-Voucher__input","toggleActive":"c-Voucher__toggleActive","discountButton":"c-Voucher__discountButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/Voucher/Voucher.scss
// module id = 904
// module chunks = 0